import { withStyles, withTheme } from '@material-ui/core/styles';
import React from 'react';
import PropTypes from 'prop-types';

// ui/ux
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';

// icons
import WarningIcon from '@material-ui/icons/Warning';

// ours
import FormTable from '../../FormTable';
import Waiting from '../../../Waiting';
import ErrorSign from '../../../ErrorSign';

// modules
import throttle from 'lodash.throttle';

// GLOBALS
const API_HOST = process.env.REACT_APP_ADMIN_API_HOST;

const styles = (theme) => ({
  filterField: {
    float: 'right',
    width: '30vw',
    color: 'white !important',
    '& .MuiFormLabel-root.Mui-focused': {
      color: theme.palette.text.secondary
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.text.secondary
    }
  },
  tooltip: {
    maxWidth: '50vw'
  }
});

class SelectForm extends React.Component {
  constructor(props) {
    super(props);
    console.log('SelectForm', JSON.stringify({ ...props, classes: null, theme: null, onComplete: null }));
    this.state = {
      forms: null,
      incomplete: true,
      error: false
    };

    // BIND
    this.onFilterChange = this.onFilterChange.bind(this);

    // THROTTLE
    this.getFormsThrottled = throttle(this.getForms.bind(this), 1500);

    // XHR
    this._xhrFormsRaw = {};

    this.TABLE_STRUCT = [
      {
        noTitle: true,
        name: ' ',
        id: 'configured_topics',
        rowMutation: (v) => {
          if (!v || v.length === 0) {
            return null;
          }

          return (
            <Tooltip
              classes={{
                tooltip: props.classes.tooltip
              }}
              title={
                <ul style={{ paddingInlineStart: props.theme.spacing(2) }}>
                  {v.map((d) => (
                    <li key={d.topic}>{`${d.topic},${d.created},${d.user}`}</li>
                  ))}
                </ul>
              }
            >
              <WarningIcon style={{ color: props.theme.palette.warning.main }} />
            </Tooltip>
          );
        }
      },

      {
        name: 'Id',
        id: 'form_id'
      },
      {
        name: 'Created',
        id: 'form_created_at'
      },
      {
        name: 'Structure',
        id: 'form_struct'
      },
      {
        name: 'Name',
        id: 'form_name'
      },
      {
        name: 'Organization',
        id: 'organization_name'
      },
      {
        name: 'Summary',
        id: 'form_summary'
      }
    ];
  }
  componentDidMount() {
    this.getForms();
  }
  componentWillUnmount() {
    this._xhrFormsRaw.cancel && this._xhrFormsRaw.cancel();
    this.getFormsThrottled.cancel();
  }
  onFilterChange(e) {
    const { value } = e.target;
    const text = value.length > 0 ? value : undefined;
    this.setState({ text, loading: true });
    this.getFormsThrottled(text);
  }
  getForms(text) {
    this._xhrFormsRaw.cancel && this._xhrFormsRaw.cancel();
    window.genericPost(`${API_HOST}/admin/v0/forms/raw`, { limit: 200, text: text }, this._xhrFormsRaw, (e, r) => {
      if (e) {
        console.error(e);
        return this.setState({
          error: true,
          forms: null,
          incomplete: false,
          loading: false
        });
      }

      this.setState({
        forms: r.map((d) => ({
          ...d,
          organization_name: d.organization_name.length < 2 ? d.organization_id : d.organization_name
        })),
        incomplete: r.length >= 200,
        loading: false,
        error: false
      });
    });
  }

  componentDidUpdate() {}

  renderTableCount() {
    const { forms, incomplete, loading } = this.state;
    if (loading || !forms) {
      return null;
    }
    if (incomplete) {
      return (
        <Typography>
          <span role="img" aria-label="warning sign">
            ⚠️{' '}
          </span>
          {forms.length} <i> of unknown </i> forms
        </Typography>
      );
    } else {
      return (
        <Typography>
          <span role="img" aria-label="green light symbol">
            🍏{' '}
          </span>
          {forms.length} forms
        </Typography>
      );
    }
  }
  render() {
    const { forms, loading, error } = this.state;
    const { classes, onComplete } = this.props;

    if (error) {
      return <ErrorSign height="40vh" />;
    }

    return (
      <React.Fragment>
        <Typography variant="h5">Select the desired form -</Typography>
        <Grid container direction="row" justifyContent="flex-end" alignItems="center" spacing={2}>
          <Grid item xs>
            {this.renderTableCount()}
          </Grid>
          <Grid item>
            <TextField className={classes.filterField} id="choose-form-filter-forms" label="Filter Forms" variant="outlined" onChange={this.onFilterChange} />
          </Grid>
        </Grid>
        {loading || !forms ? <Waiting height="40vh" /> : <FormTable tableStruct={this.TABLE_STRUCT} forms={forms} onFormSelect={onComplete} loading={false} />}
      </React.Fragment>
    );
  }
}

SelectForm.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,

  onComplete: PropTypes.func.isRequired
};
SelectForm.defaultProps = {};

export default withTheme(withStyles(styles)(SelectForm));
